import { Directive, ElementRef, inject } from '@angular/core';

/**
 * Directive applied to an element to make it usable
 * as a connection point for an autocomplete panel.
 */
@Directive({
  selector: '[ttAutocompleteOrigin]',
  exportAs: 'ttAutocompleteOrigin',
  standalone: true,
})
export class AutocompleteOriginDirective {
  elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}
